'use client'

import dynamic from 'next/dynamic'
import React, { FC, ReactNode } from 'react'

import LoadingMask from '@/components/Top/LoadingMask'

type Props = {
  loadingMask: ReactNode
  headerComponent: ReactNode
  productSection: ReactNode
  campaignSection: ReactNode
  newsSection: ReactNode
  topicsSection: ReactNode
  journalSection: ReactNode
}

const TopPageLogic = dynamic(() => import('@/components/Page/Top/TopPage/topPageLogic'), {
  ssr: true,
})

// eslint-disable-next-line no-unused-vars
const TopPage: FC<Props> = ({
  loadingMask,
  headerComponent,
  productSection,
  campaignSection,
  newsSection,
  topicsSection,
  journalSection,
}) => {
  return (
    <>
      <TopPageLogic
        headerComponent={headerComponent}
        productSection={productSection}
        campaignSection={campaignSection}
        newsSection={newsSection}
        topicsSection={topicsSection}
        journalSection={journalSection}
      >
        <>
          <LoadingMask>
            <div className={'p-loading'}>{loadingMask}</div>
          </LoadingMask>
        </>
      </TopPageLogic>
    </>
  )
}

export default TopPage
